export default {"src":"/_next/static/media/secure-user.e146f93a.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};